import React from "react";
import "../css/PublicVsPrivate.css";

const PublicVsPrivate = () => {

  const privatePoints = [
    "Modern classrooms and advanced learning facilities",
    "Student-centred teaching approach",
    "Focus on academic excellence and personality development",
    "Wide range of sports and co-curricular activities",
    "Better individual attention with supportive teachers",
    "Technology-enabled learning environment"
  ];


  const publicPoints = [
    "Affordable education opportunities",
    "Government-supported learning system",
    "Inclusive education environment",
    "Standardised curriculum structure",
    "Diverse student community",
    "Strong foundation in basic education"
  ];


  return (
    <div className="pvp-page">


      

      <section className="pvp-hero">

        <div className="pvp-overlay">

          <h1>
            Public School vs Private School
          </h1>

          <p>
            Understanding the difference helps parents choose
            the right educational journey for their child.
          </p>

          <button>
            Enquire Now
          </button>

        </div>

      </section>



      {/* INTRO */}

      <section className="pvp-intro">

        <h2>
          Public School vs Private School
        </h2>

        <p>
          Choosing the right school is one of the most important
          decisions for your child's future. Sahara Public Secondary
          School provides a nurturing environment where students
          develop academically, socially and emotionally.
        </p>

      </section>




      {/* CARDS */}

      <section className="pvp-cards">


        <div className="pvp-card private">

          <h3>
            Private Schools
          </h3>


          <ul>

            {
              privatePoints.map((item,index)=>(
                <li key={index}>
                  {item}
                </li>
              ))
            }

          </ul>

        </div>



        <div className="pvp-card public">


          <h3>
            Public Schools
          </h3>


          <ul>

            {
              publicPoints.map((item,index)=>(
                <li key={index}>
                  {item}
                </li>
              ))
            }

          </ul>


        </div>



      </section>




      {/* COMPARISON */}


      <section className="compare">


        <h2>
          Comparison Between Public and Private Schools
        </h2>



        <div className="table">


          <div className="row head">

            <div>
              Feature
            </div>

            <div>
              Private School
            </div>

            <div>
              Public School
            </div>

          </div>



          <div className="row">

            <div>
              Facilities
            </div>

            <div>
              Advanced infrastructure and learning resources
            </div>

            <div>
              Basic facilities with limited resources
            </div>

          </div>



          <div className="row">

            <div>
              Curriculum
            </div>

            <div>
              Flexible and innovative learning methods
            </div>

            <div>
              Standard curriculum structure
            </div>

          </div>



          <div className="row">

            <div>
              Student Attention
            </div>

            <div>
              Smaller classes with personalised support
            </div>

            <div>
              Larger classrooms
            </div>

          </div>


        </div>


      </section>





      {/* SAHARA SECTION */}


      <section className="sahara-choice">


        <h2>
          Why Choose Sahara Public Secondary School?
        </h2>


        <p>

          At Sahara Public Secondary School, we combine quality
          education, experienced educators, modern facilities and
          value-based learning to prepare students for future success.

        </p>


        <button>
          Apply Admission
        </button>


      </section>
      {/* WHY PARENTS CHOOSE PRIVATE EDUCATION */}

<section className="why-private">

<h2>
Why Parents Choose Private Schools
</h2>

<p>
Private schools focus on providing a complete learning
experience with modern facilities, innovative teaching methods
and opportunities beyond academics.
</p>


<div className="feature-grid">


<div className="feature-box">

<h3>
Modern Infrastructure
</h3>

<p>
Smart classrooms, science laboratories, libraries and
technology-enabled learning spaces help students learn better.
</p>

</div>



<div className="feature-box">

<h3>
Individual Attention
</h3>

<p>
Teachers understand every student's learning needs and
provide personal guidance for improvement.
</p>

</div>



<div className="feature-box">

<h3>
Holistic Development
</h3>

<p>
Students participate in sports, arts, leadership activities
and skill development programs.
</p>

</div>


</div>

</section>





{/* SAHARA APPROACH */}


<section className="learning-approach">


<div className="approach-content">


<h2>
Sahara Public School Learning Approach
</h2>


<p>

At Sahara Public Secondary School, education goes beyond
textbooks. We focus on developing creativity, confidence,
critical thinking and leadership qualities among students.

</p>


<ul>

<li>
✔ Student-centred teaching methodology
</li>

<li>
✔ Experienced and supportive educators
</li>

<li>
✔ Balanced academic and co-curricular activities
</li>

<li>
✔ Safe and positive learning environment
</li>

<li>
✔ Preparation for future challenges
</li>

</ul>


</div>


<div className="approach-image">

<img 
src="/images/fc.jpeg"
alt="Sahara Learning"
/>

</div>


</section>






{/* IMPORTANT FACTORS */}


<section className="parent-factors">


<h2>
Factors Parents Should Consider While Choosing A School
</h2>



<div className="factor-grid">


<div>
<h3>
Academic Excellence
</h3>

<p>
Quality curriculum and teaching methods build a strong
foundation for students.
</p>

</div>



<div>

<h3>
School Environment
</h3>

<p>
A safe, friendly and supportive environment helps children
grow confidently.
</p>

</div>



<div>

<h3>
Future Opportunities
</h3>

<p>
Schools should provide exposure to activities, skills and
career development.
</p>

</div>


<div>

<h3>
Values & Discipline
</h3>

<p>
Strong moral values and discipline prepare students for life.
</p>

</div>


</div>


</section>






{/* FINAL CTA */}


<section className="admission-banner">


<h2>
Give Your Child The Right Educational Foundation
</h2>


<p>
Join Sahara Public Secondary School and provide your child
with quality education, opportunities and a brighter future.
</p>


<button>
Start Admission Process
</button>


</section>
{/* CONCLUSION SECTION */}

<section className="pvp-conclusion">

  <div className="conclusion-container">

    <h2>
      Conclusion: Choosing The Right School For Your Child
    </h2>


    <p>
      The choice between a public school and a private school
      depends on every child's individual needs, learning goals
      and family expectations. While both education systems have
      their own advantages, selecting a school that provides a
      supportive environment, quality education and opportunities
      for overall development is essential.
    </p>


    <p>
      At Sahara Public Secondary School, we believe that every
      child deserves an education that builds knowledge,
      confidence, creativity and strong values. Our focus is to
      provide students with a balanced learning experience through
      academics, activities, technology and character development.
    </p>


    <p>
      By choosing Sahara Public Secondary School, parents become
      partners in creating a strong foundation for their child's
      successful future.
    </p>


    <button>
      Explore Sahara Admissions
    </button>


  </div>


</section>



    </div>
  );
};


export default PublicVsPrivate;